import { use, useCallback, useEffect } from 'react';
import { CarouselContext, CarouselDispatchContext } from './CarouselContext';

export const useCarousel = () => use(CarouselContext);
export const useCarouselDispatch = ({
  trackRef,
}: {
  trackRef: React.RefObject<HTMLUListElement | null>;
}) => {
  const { setAtStart, setAtEnd } = use(CarouselDispatchContext);
  // sets start and end state for carousel navigation
  const updateEdgeState = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setAtStart(scrollLeft <= 0);
    setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
    // unnecessary to include trackRef in deps, but to match react rules of hooks for react compiler, it is added
  }, [setAtEnd, setAtStart, trackRef]);

  // initial check for start and end state
  useEffect(() => {
    updateEdgeState();
  }, [updateEdgeState]);

  return { setAtStart, setAtEnd, updateEdgeState };
};
